export enum TemplateTypes {
  Contract = 'contract',
  Document = 'document',
  Form = 'form',
}

export const templateTypeOptions = [
  { value: TemplateTypes.Contract, label: $localize`Contract` },
  { value: TemplateTypes.Document, label: $localize`Printout` },
  { value: TemplateTypes.Form, label: $localize`Form` },
]
